import { Link } from 'react-router-dom';

import React from 'react';
import Joi from 'joi';
import Form from '../common/form';
import Progress from '../themed/progress';

import withRouter from '../hoc/withRouter';
import routes from '../../utils/routes';

import * as userService from '../../services/userService';
import * as toastService from '../../services/toastService';
import * as utils from '../../utils/utilities';

import css from '../pages/auth/auth.module.scss';

class ForgotPasswordForm extends Form {
	state = {
		data: { email: '' },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		email: Joi.string()
			.email({ tlds: false })
			.required()
			.label('Email Address'),
	};

	postData = async () => {
		const { email } = this.state.data;
		await userService.forgotPassword(email, this.handleProgressChange);

		const props: any = this.props;
		props.navigate(routes.login.fullPath);
	};

	doSubmit = (): void => {
		toastService.promise(this.postData(), {
			loading: 'Sending Reset Mail',
			success: () => 'Mail Sent Successfully!',
			error: utils.getErrorMessage,
		});
	};

	render() {
		return (
			<React.Fragment>
				<Progress progress={this.state.progress} />

				<form autoComplete="off" onSubmit={this.handleSubmit}>
					{this.renderInput({
						type: 'email',
						name: 'email',
						placeholder: 'e.g. johndoe@russelsmithgroup.com',
						label: 'Email Address',
					})}

					<div className="my-3 d-flex justify-content-between align-items-center">
						{this.renderButton('Send')}

						<Link
							to={routes.login.pathname}
							className={css.newLoginForgotPassword}
						>
							Back to Login
						</Link>
					</div>
				</form>
			</React.Fragment>
		);
	}
}

export default withRouter(ForgotPasswordForm);
